import { Group } from "@mantine/core";

import { IconActivityHeartbeat } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

export function EmptyVitals() {
  return (
    <Group
      p="xs"
      gap="xs"
      w="100%"
      bg="gray.0"
      display="flex"
      justify="center"
      style={{ borderRadius: "var(--mantine-radius-xs)" }}
    >
      <IconActivityHeartbeat size={18} color="var(--mantine-color-gray-6)" />
      <TextWrapper fz="md" c="gray.7" variant="default">
        No vitals have been added.
      </TextWrapper>
    </Group>
  );
}
